import React from 'react';
import PropTypes from 'prop-types';
import Text from '../Text/index';
import Button from '../Button/index';
import { SectionCareerHero } from './styles';

const STCareerHeroSection = ({
  backgroundImg,
  backgroundColor,
  title,
  titleColor,
  buttonTitle,
  buttonType,
  buttonLinkTo,
  ...otherProps
}) => (
  <SectionCareerHero
    backgroundColor={backgroundColor}
    backgroundImg={backgroundImg}
    titleColor={titleColor}
    buttonType={buttonType}
    {...otherProps}
  >
    <div className="section-career-hero--overlay" />
    <div className="section-career-hero--container">
      <Text type="h2" className="section-career-hero--title">
        {title}
      </Text>
      <Button
        className="section-career-hero--button"
        type={'tertiary'}
        dataPosition="Careers Hero - CTA"
        to={'/job-openings'}
      >
        {buttonTitle}
      </Button>
    </div>
  </SectionCareerHero>
);

STCareerHeroSection.propTypes = {
  title: PropTypes.string,
  titleColor: PropTypes.string,
  backgroundImg: PropTypes.object,
  backgroundColor: PropTypes.string,
  buttonTitle: PropTypes.string,
  buttonType: PropTypes.string,
  buttonLinkTo: PropTypes.string,
};

export default STCareerHeroSection;
